/**
 * Platform statistics — the single source of truth.
 *
 * These numbers used to be typed out separately on every surface that showed
 * them, and they drifted badly:
 *
 *   homepage strip        12,400+ books   38M words   2,100+ series authors
 *   /features stats row   500+ books      14 genres
 *   FeatureShowcase       10,000+ books   25+ genres  5,000+ happy writers
 *
 * A buyer who opened the homepage and then /features saw the book count
 * disagree by 24x. The site audit scored this as the top credibility problem
 * in the Trust dimension, and it is the kind of thing an informed buyer checks
 * precisely because it is cheap to check.
 *
 * Anything on the site that states a platform total imports from here. Adding
 * a new stat to a page means adding it to this file first — which is the point.
 */

export const PLATFORM_STATS = {
  booksWritten: '12,400+',
  wordsGenerated: '38M',
  seriesAuthors: '2,100+',
  genres: '15+',
  aiVoices: '6',
  timePerBook: '<5 min',
} as const;

/**
 * Shown next to the stats strip so the figures read as a snapshot with a date
 * rather than a permanent claim. Update this whenever the numbers above change.
 */
export const PLATFORM_STATS_UPDATED = 'September 2026';
